<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#68D389"
      size="128"
      is-full-screen
    />
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-start>
      <v-flex xs12 align-self-center text-center>
        <v-layout wrap justify-start pb-5>
          <v-flex xs12 pt-lg-6 pt-md-6 pt-sm-6 pt-xs-2 align-self-center>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap py-5 pl-lg-12 pl-md-1 class="bg">
      <v-flex xs12 sm6 md3 text-center>
        <v-layout wrap justify-center>
          <v-flex xs3 sm4 md6 lg4>
            <v-img src="../../assets/tur.png" width="100%"></v-img>
          </v-flex>
          <v-flex>
            <v-layout wrap justify-start>
              <v-flex
                xs12
                text-center
                offset-xs1
                offset-sm0
                offset-md0
                offset-lg0
              >
                <span class="main">Species</span>
              </v-flex>
              <v-flex
                pt-lg-5
                xs12
                text-center
                offset-xs1
                offset-sm0
                offset-md0
                offset-lg0
              >
                <span class="sub">{{ data.numberOfSpecies }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md3 text-center>
        <v-layout wrap justify-start>
          <v-flex xs4 sm4 md8 lg5>
            <v-img src="../../assets/search.png"></v-img>
          </v-flex>
          <v-flex lg6>
            <v-layout wrap justify-start>
              <v-flex xs12 text-center>
                <span class="main">Observations</span>
              </v-flex>
              <v-flex xs12 text-center pt-lg-5>
                <span class="sub">{{ data.observationcount }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md3 text-center>
        <v-layout wrap justify-center>
          <v-flex xs4 sm5 md10 lg6>
            <v-img src="../../assets/rescue.png" width="100%"></v-img>
          </v-flex>
          <v-flex>
            <v-layout wrap justify-start>
              <v-flex xs12 text-center>
                <span class="main">Rescues</span>
              </v-flex>
              <v-flex pt-lg-5 xs12 text-center>
                <span class="sub">{{ data.rescuecount }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm5 md3 text-center>
        <v-layout wrap justify-center>
          <v-flex xs4 sm6 md9 lg5 px-5>
            <v-img src="../../assets/users.png"></v-img>
          </v-flex>
          <v-flex>
            <v-layout wrap justify-start>
              <v-flex xs12 text-center>
                <span class="main">Users</span>
              </v-flex>
              <v-flex pt-lg-5 xs12 text-center>
                <span class="sub">{{ data.usercount }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap px-5 py-2 justify-center>
      <v-flex xs12 sm12 md4 lg4>
        <v-layout wrap justify-center>
          <v-flex xs12 text-center>
            <span class="main">Top Regions</span>
          </v-flex>
          <v-flex xs12 pt-2>
            <!-- <v-img contain max-height="300px" style="color: green" src="../../assets/ind.png"></v-img> -->

            <div id="mapnew2"></div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md4 lg4>
        <v-layout wrap justify-center>
          <v-flex xs12 text-center>
            <span class="main">Observations</span>
          </v-flex>
          <v-flex v-if="observe.length > 0" xs12 pt-2>
            <apexchart
              width="100%"
              height="300px"
              type="bar"
              :options="chartOptions1"
              :series="series"
            ></apexchart>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md4 lg4>
        <v-layout wrap justify-center>
          <v-flex xs12 text-center>
            <span class="main">Rescues</span>
          </v-flex>
          <v-flex v-if="res.length > 0" xs12 pt-2>
            <apexchart
              width="100%"
              height="300px"
              type="bar"
              :options="chartOptions2"
              :series="rescue"
            ></apexchart>
          </v-flex>

          <v-flex
            xs12
            py-8
            :align-self-center="
              $vuetify.breakpoint.name == 'xs' ||
              $vuetify.breakpoint.name == 'sm' ||
              $vuetify.breakpoint.name == 'md'
                ? true
                : false
            "
            align-self-end
            :text-center="
              $vuetify.breakpoint.name == 'xs' ||
              $vuetify.breakpoint.name == 'sm' ||
              $vuetify.breakpoint.name == 'md'
                ? true
                : false
            "
            :text-right="$vuetify.breakpoint.name !== 'xs' ? true : false"
          >
            <v-btn class="btn" text>
              <router-link
                style="text-decoration: none"
                :to="{ name: 'apexchart' }"
              >
                View all
              </router-link>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
 <script
    src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&libraries=visualization,drawing">
</script>
<script>
import axios from "axios";

var marker;
var drawingManager;
var all_overlays = [];
let heatmap;
let heatmap2;
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      species: {},
      contributers: [],
      counts: [],
      dataMap: [],
      dataMap2: [],
      data: [],
      map: null,
      map2: null,
      // lat: "",
      k: 0,
      // lng: "",
      currentPlace: null,
      places: [],
      observe: [],
      res: [],
      series: [
        {
          name: "",
          data: [],
        },
      ],
      rescue: [
        {
          name: "",
          data: [],
        },
      ],
      chartOptions1: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        xaxis: {
          categories: [],
        },
      },
      chartOptions2: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        xaxis: {
          categories: [],
        },
      },
      fill: {
        color: "#5753C4F3",
      },
      window_open: false,
      textA: [
        {
          title: "Digital field guide",
          desc:
            "A ready to go, lightweight field guide on Indian Freshwater Turtles and Tortoises.",
        },
        {
          title: "Share your sightings/photos",
          desc: "Share your sightings and photos with a larger audience.",
        },
        {
          title: "Be part of the Turtle network",
          desc:
            "Your inputs help build a good dataset on Indian turtles and tortoises which will help future conservation efforts.",
        },
        {
          title: "List of assistance facilities",
          desc:
            "Provides a list of rescue centers and assistance facilities to turn to when you have a turtle in distress.",
        },
      ],
    };
  },
  components: {
    // Screenshots,
  },
  beforeMount() {
    this.getData();
    this.getClients();
  },
  methods: {
    DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y,h:mm:ss a") : "";
    },
    changeGradient() {
      const gradient = [
        "rgba(0, 255, 255, 0)",
        "rgba(0, 255, 255, 1)",
        "rgba(0, 191, 255, 1)",
        "rgba(0, 127, 255, 1)",
        "rgba(0, 63, 255, 1)",
        "rgba(0, 0, 255, 1)",
        "rgba(0, 0, 223, 1)",
        "rgba(0, 0, 191, 1)",
        "rgba(0, 0, 159, 1)",
        "rgba(0, 0, 127, 1)",
        "rgba(63, 0, 91, 1)",
        "rgba(127, 0, 63, 1)",
        "rgba(191, 0, 31, 1)",
        "rgba(255, 0, 0, 1)",
      ];
      heatmap.set("gradient", heatmap.get("gradient") ? null : gradient);
      heatmap2.set("gradient", heatmap2.get("gradient") ? null : gradient);
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/stats",
      })
        .then((response) => {
          if (response.data.status) {
            this.data = response.data.data;
            // this.species = response.data.data.sightings;
            // this.contributers = response.data.data.contributers;
            this.counts = response.data.data;
            this.observe = response.data.data.topobservationregions;
            for (var k = 0; k < 5; k++) {
              this.chartOptions1.xaxis.categories.push(this.observe[k].state);
              this.series[0].data.push(this.observe[k].count);
            }
            this.res = response.data.data.toprescueregions;
            for (var j = 0; j < 5; j++) {
              this.chartOptions2.xaxis.categories.push(this.res[j].state);
              this.rescue[0].data.push(this.res[j].count);
            }

            // this.dataMap = response.data.data.mapData;
            // var vm = this;
            // var mapData = [];
            // for (var i = 0; i < vm.dataMap.length; i++) {

            //   mapData.push(
            //     new google.maps.LatLng(
            //       vm.dataMap[i].location[1],
            //       vm.dataMap[i].location[0]
            //     )
            //   );
            // }
            // vm.map = new google.maps.Map(document.getElementById("mapnew"), {
            //   zoom: 5,
            //   center: { lat: 20.38, lng: 80.12 },
            //   // center: { lat: 9.528339, lng: 76.822503 },
            //   mapTypeId: "satellite",
            // });
            // heatmap = new google.maps.visualization.HeatmapLayer({
            //   data: mapData,
            //   map: vm.map,
            // });
            // this.changeGradient()
            // this.changeRadius()
          }
          this.appLoading = false;
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },

    getClients() {
      axios({
        method: "GET",
        url: "/user/allClients",
        params: {
          page: 0,
          count: 0,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.dataMap2 = response.data.data;
            var vmm = this;
            var mapData2 = [];
            for (var i = 0; i < vmm.dataMap2.length; i++) {
              if (vmm.dataMap2[i].location.length !== 0) {
                mapData2.push(
                  new google.maps.LatLng(
                    vmm.dataMap2[i].location[1],
                    vmm.dataMap2[i].location[0]
                  )
                );
              }
            }
            vmm.map2 = new google.maps.Map(document.getElementById("mapnew2"), {
              zoom: 5,
              center: { lat: 20.38, lng: 80.12 },
              mapTypeId: "satellite",
            });
            heatmap2 = new google.maps.visualization.HeatmapLayer({
              data: mapData2,
              map: vmm.map2,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.ServerError = true;
        });
    },
    // changeRadius() {
    //     heatmap.set("radius", heatmap.get("radius") ? null : 1);
    //     heatmap2.set("radius", heatmap2.get("radius") ? null : 20);
    //   },
    openWindow() {
      this.window_open = true;
    },
    handleMrker(m) {
      this.activeMark = m;
      this.infoWindowOpened = true;
    },
    handleMarkClosed() {
      this.activeMark = {};
      this.infoWindowOpened = false;
    },
  },
};
</script>

<style>
.triangle-up {
  width: 0;
  height: 0;
  border-left: 160px solid transparent;
  border-right: 160px solid transparent;
  border-bottom: 100px solid #7fd439;
  opacity: 0.8;
  top: 0px;
}

.rectangle {
  height: 380px;
  width: 320px;
  background-color: #7fd439;
  opacity: 0.8;
  /* z-index: -1; */
  -webkit-box-shadow: -5px 14px 23px -18px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -5px 14px 23px -18px rgba(0, 0, 0, 0.75);
  box-shadow: -5px 14px 23px -18px rgba(0, 0, 0, 0.75);
}

.triangle-upXL {
  width: 0;
  height: 0;
  border-left: 272px solid transparent;
  border-right: 272px solid transparent;
  border-bottom: 100px solid #7fd439;
  opacity: 0.8;
  top: 0px;
}

.rectangleXL {
  height: 420px;
  width: 544px;
  background-color: #7fd439;
  opacity: 0.8;
  /* z-index: -1; */
  -webkit-box-shadow: -5px 14px 23px -18px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -5px 14px 23px -18px rgba(0, 0, 0, 0.75);
  box-shadow: -5px 14px 23px -18px rgba(0, 0, 0, 0.75);
}

.vl {
  border-left: 3px dashed black;
  height: 450px;
}
.bg {
  background-color: #bde9b5f3;
}
.main {
  font-family: poppins-bold;
  font-size: 22px;
}
.sub {
  color: #8a8f89f3;
  font-size: 35px;
  font-weight: bold;
}
.btn {
  text-transform: none;
  font-weight: bold;
}
/* #mapnew {
  height: 430px;
  width: 100%;
  margin: 0px;
  padding: 0px;
} */

#mapnew2 {
  height: 420px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>